import SubPage from '../../subpages/SubPage';
import AdminSummary from '../../components/AdminSummary';
import AdminReceptionist from '../../components/AdminReceptionist';
import AdminPayment from '../../components/AdminPayment';
import AdminApplicationGroup from '../../components/AdminApplicationGroup';
import AdminApplication from '../../components/AdminApplication';
import { Container, Table } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';

const ReceptionManagement = () => {
  const title = '접수 관리';
  const parent_link = 'admin/reception';   // 반드시, 상대경로로 시작
  const side_list = [
    ['summary', '신청현황'],
    ['receptionist?pageNo=1&rowCount=10', '신청관리'],
    ['payment?pageNo=1&rowCount=10', '결제확인'],
    ['application/individual', '대리접수/수정(개인)'],
    ['application/group', '대리접수/수정(단체)'],
  ];
  const bg_info = {
    link: 'https://user-images.githubusercontent.com/46194004/123917479-ce698400-d9bd-11eb-9599-975e219cee76.png',
    text: title,
  };
  return (
    <div>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        isOnePage={false}
        background_info={bg_info}
      />
      <Container className="col-10 offset-2 ps-5">
        <Switch>
          <Route path={`/${parent_link}/${side_list[0][0]}`} component={AdminSummary} exact={true} />
          <Route path={`/${parent_link}/receptionist`} component={AdminReceptionist} />
          <Route path={`/${parent_link}/payment`} component={AdminPayment} />
          <Route path={`/${parent_link}/${side_list[3][0]}`} component={AdminApplication} />
          <Route path={`/${parent_link}/${side_list[4][0]}`} component={AdminApplicationGroup} />
        </Switch>
      </Container>
    </div>
  );
};
export default ReceptionManagement;
